import * as Yup from 'yup';

export const stringBeautifyValidator = (errorText: string = 'Field is required') => {
	return Yup.string().required(errorText);
};

export const stringBeautifyLengthValidator = (errorText: string = 'Field is required', errLength: string, lenMin: number) => {
	return Yup.string()
		.required(errorText)
		.test('len', errLength, (val) => val.length >= lenMin);
};

export const numberBeautifyValidator = (
	typeError: string = 'Value must be a number',
	positive: string = 'Value must be greater than zero',
	required: string = 'Field is required',
	integer: string = 'Value must be a whole number',
) => {
	return Yup
		.number()
		.typeError(typeError)
		.positive(positive)
		.integer(integer)
		.required(required);
};

export const validateFile = (data, field, maxFile, formatErrorCapture) => {
	const errorFormat = formatErrorCapture;
	const errorSize = 'Image max file size is 10MB - Please upload a smaller image';
	data.size > maxFile ? field.form.setFieldError('filePath', errorSize) : field.form.setFieldError('filePath', errorFormat);
};
